import { FC } from 'react';
import { Grid, GridProps } from '@mui/system';

const CustomContainer: FC<GridProps> = ({ children, ...props }) => (
  <Grid container rowSpacing={6.5} width="100%" {...props}>
    {children}
  </Grid>
);

export const CustomCompactContainer: FC<GridProps> = ({ children, ...props }) => (
  <Grid container rowSpacing={5} size={{ xs: 12 }} {...props}>
    {children}
  </Grid>
);

export default CustomContainer;
